<div class="row geopromo-row" [style.background-image]="getBackGround()">
  <div class="col-lg-12 col-md-12 col-sm-8 geopromo-col">
  <div class="col-md-4 col-sm-6 geopromo-container" *ngFor="let geodestino of geodestinos">
    <cms-geodestino-promo-item [geodestino]="geodestino"></cms-geodestino-promo-item>
  </div>
</div>
</div>
